import type { Filter } from '@unifyapps/network/generated/models/filter';
import { Op } from '@unifyapps/network/generated/models/op';
import { InterfacePageEntityComponentType } from '@unifyapps/defs/types/page';
import type { InterfaceComponent } from '../types/interfaceComponent';
import { EMPTY_ARRAY } from '../../consts/empty';

export enum InterfaceComponentType {
  PAGE = 'PAGE',
  MODULE = 'MODULE',
  WALKTHROUGH = 'WALKTHROUGH',
}

export const PAGE_COMPONENT_FILTER = [
  {
    field: 'properties.componentType',
    op: Op.EQUAL,
    values: [InterfaceComponentType.PAGE],
  },
];

export const MODULE_COMPONENT_FILTER = [
  {
    field: 'properties.componentType',
    op: Op.EQUAL,
    values: [InterfaceComponentType.MODULE],
  },
];

export const WALKTHROUGH_COMPONENT_FILTER = [
  {
    field: 'properties.componentType',
    op: Op.EQUAL,
    values: [InterfaceComponentType.WALKTHROUGH],
  },
];

export const getLookupInterfaceQueryFilter = ({
  interfaceId,
  interfaceComponent,
  searchFilters = [],
}: {
  interfaceId: string;
  interfaceComponent?: InterfaceComponent;
  searchFilters?: Filter[];
}) => {
  let interfaceComponentFilter = EMPTY_ARRAY as Filter[];

  if (interfaceComponent) {
    switch (interfaceComponent.type) {
      case InterfacePageEntityComponentType.MODULE:
      case InterfacePageEntityComponentType.WALKTHROUGH:
        interfaceComponentFilter = [
          {
            field: 'id',
            op: Op.EQUAL,
            values: [interfaceComponent.id],
          },
        ];
        break;
      case InterfacePageEntityComponentType.PAGE:
        interfaceComponentFilter = [
          {
            op: Op.OR,
            values: [
              {
                field: 'properties.slug',
                op: Op.EQUAL,
                values: [interfaceComponent.slug],
              },
              {
                // todo: backward compatibility
                // this filter is for backward compatibility, when slug is not stored in properties of interface component
                // When every page component has slug in it, then this OR filter won't be needed
                field: 'id',
                op: Op.EQUAL,
                values: [interfaceComponent.slug],
              },
            ],
          },
        ];
        break;
    }
  }

  return {
    filter: {
      op: Op.AND,
      values: [
        { field: 'properties.interfaceId', op: Op.EQUAL, values: [interfaceId] },
        ...interfaceComponentFilter,
        ...searchFilters,
      ],
    },
    sorts: [
      {
        field: 'properties.name',
        order: 'ASC' as const,
      },
    ],
    page: {
      limit: 100,
      offset: 0,
    },
  };
};
